jQuery($ => {
  class ServiceAreaMap {
    constructor(element) {
      this._ = element;
      this._element = $(element);
      this._map = this._element.find('.o-service-area-map__map');
      this._markers = this._element.find('.o-service-area-map__corodinates');

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      async function initMap(mapBlock) {
        const { Map, InfoWindow } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
        let $markers = $(mapBlock).find('.o-service-area-map__coordinates');
        let zoom = 8;

        const markersArr = [];
        const map = new Map(mapBlock, {
          center: { lat: 0, lng: 0 },
          mapId: "locations-map",
          mapTypeControl: false,
          streetViewControl: false,
          zoomControl: true
        });

        const infoWindow = new google.maps.InfoWindow({
          content: '',
          disableAutoPan: true,
        })

        $($markers).each(function (index, $marker) {
          const lat = parseFloat($marker.getAttribute("data-lat"));
          const lng = parseFloat($marker.getAttribute("data-lng"));

          markersArr.push({ lat: lat, lng: lng, title: $marker.getAttribute("data-title"), address: $marker.getAttribute("data-address") });
        });

        const bounds = new google.maps.LatLngBounds();

        markersArr.map((position, i) => {
          const marker = new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: { lat: position.lat, lng: position.lng },
          });

          // marker.addListener('click', () => {
          //   infoWindow.setContent('<div class="o-map-block__info-window"><h3 class="u-h4">' + position.title + '</h3><p>' + position.address + '</p></div>');
          //   infoWindow.open(map, marker);
          // });
          bounds.extend(marker.position);
        });

        if (markersArr.length === 1) {
          map.setCenter(bounds.getCenter());
          map.setZoom(zoom);
        } else {
          map.fitBounds(bounds);

          google.maps.event.addListenerOnce(map, "bounds_changed", () => {
            map.setZoom(zoom);
          });
        }

        const serviceArea = markersArr.map((position, i) => {
          return { lat: position.lat, lng: position.lng };
        });

        const boundaries = new google.maps.Polygon({
          paths: serviceArea,
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#FF0000',
          fillOpacity: 0.35
        })

        boundaries.setMap(map);
      }


      $(this._map).each(function (index, $mapBlock) {
        initMap($mapBlock);
      });
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.service_area_map = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].service_area_map = new ServiceAreaMap(_[i], opt);
      else
        ret = _[i].service_area_map[opt].apply(_[i].service_area_map, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.o-service-area-map').service_area_map();
});